














import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { format } from "quasar";

@Component
export default class FilePicker extends Vue {
  @Ref("file")
  fileInput!: HTMLInputElement;

  @Prop({ type: String, default: "*" })
  accept!: string;

  @Prop({ type: String, default: "Scegli un file" })
  label!: string;

  @Prop({ type: Boolean, default: false })
  disable!: boolean;

  value: File | null = null;

  async fileChanged(e: Event) {
    this.value = null;

    const files = (e.target as HTMLInputElement).files || [];
    if (files.length > 0) {
      try {
        const file = files[0];
        const base64 = await this.getBase64(file);

        this.value = file;
        this.$emit("change", { file, base64 });
      } catch (e) {
        this.value = null;
      }
    }
  }

  getBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = reader.result as string;
        const matches = result.match(/^data:[^;]+;base64,(.*)$/);

        if (matches && matches[1]) {
          resolve(matches[1]);
        } else {
          reject("invalid format");
        }
      };

      reader.onerror = e => {
        reject(e);
      };
    });
  }

  formatSize(size: number) {
    return format.humanStorageSize(size);
  }

  open() {
    this.fileInput.click();
  }

  reset() {
    this.value = null;
    this.fileInput.value = "";
  }
}
